import React from 'react'
import { Tab } from '@material-ui/core'
import type { TabProps as MuiTabProps } from '@material-ui/core/Tab'
import type { WithStyles, Theme } from '@material-ui/core/styles'
import { withStyles, createStyles } from '@material-ui/core/styles'

const styles = (theme: Theme) => {
  return createStyles({
    root: {
      ...theme.typography.overline,
      color: theme.paintscout.palette.brand.Neutral.P40,
      minWidth: '0',
      minHeight: '0',
      padding: theme.spacing(1, 0),
      '&:hover': {
        color: theme.palette.primary.main,
        opacity: 1
      }
    },
    wrapper: {
      minWidth: '0'
    },
    selected: {
      color: theme.palette.primary.main
    }
  })
}

export interface TabProps extends WithStyles<typeof styles>, Omit<MuiTabProps, 'classes'> {
  children?: React.ReactNode
}

const CustomizedTab = (props: TabProps) => (
  <Tab disableRipple {...props}>
    {props.children}
  </Tab>
)

export default withStyles(styles)(CustomizedTab)
